import { useMutation } from '@tanstack/react-query';
import { setRegistrationLanguage } from '../requests';

export function useSetRegistrationLanguage() {
  const mutation = useMutation({
    mutationFn: setRegistrationLanguage,
  });

  return {
    setRegistrationLanguage: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
}
